export default __webpack_public_path__ + "static/media/image18.df83686b.jpg";